<template>
  <div class="container-fluid py-4 users-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">

        <div class="icon-box">
          <i class="bi bi-pencil-square"></i>
        </div>

        <div>
          <h2 class="fw-bold mb-0 text-white">
            Modification d'un Utilisateur
          </h2>

          <small class="text-white-50">
            Mise à jour des informations utilisateur
          </small>
        </div>

      </div>

      <router-link
        class="btn btn-light btn-lg shadow-sm btn-boutique"
        :to="{ name: 'utilisateur' }"
      >
        <i class="bi bi-arrow-left-circle me-2"></i>
        Retour
      </router-link>

    </div>

    <!-- ================= CARD ================= -->
    <div class="card shadow-sm card-boutique p-4">

      <div class="row g-4">

        <!-- NOM -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom</label>

          <input v-model="user.nom"
                 type="text"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.nom }">

          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- PRENOM -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Prénom</label>

          <input v-model="user.prenom"
                 type="text"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.prenom }">

          <div class="invalid-feedback">{{ error.prenom }}</div>
        </div>

        <!-- USERNAME -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom utilisateur</label>

          <input v-model="user.username"
                 type="text"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.username }">

          <div class="invalid-feedback">{{ error.username }}</div>
        </div>

        <!-- EMAIL -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Email</label>

          <input v-model="user.email"
                 type="email"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.email }">

          <div class="invalid-feedback">{{ error.email }}</div>
        </div>

        <!-- ROLE -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Rôle</label>

          <select v-model="user.typeUser"
                  class="form-select form-control-boutique"
                  :class="{ 'is-invalid': error.type }">

            <option value="" disabled>-- Sélectionnez --</option>

            <option
              v-for="type in typesUser.filter(t => t.nom !== 'Super Admin')"
              :key="type.id"
              :value="type.id"
            >
              {{ type.nom }}
            </option>

          </select>

          <div class="invalid-feedback">{{ error.type }}</div>
        </div>

        <!-- STATUS -->
        <div class="col-md-6 d-flex align-items-center">

          <div class="status-switch form-check form-switch">

            <input class="form-check-input"
                   type="checkbox"
                   v-model="user.enabled">

            <label class="form-check-label fw-semibold ms-2">
              Utilisateur actif
            </label>

          </div>

        </div>

      </div>

      <!-- ================= ACTIONS ================= -->
      <div class="d-flex justify-content-end gap-3 mt-4">

        <button class="btn btn-outline-secondary" @click="cancel">
          Annuler
        </button>

        <button class="btn btn-primary-medical px-4"
                :disabled="isLoading"
                @click="updateUser">

          <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>

          <i v-else class="bi bi-save me-1"></i>

          {{ isLoading ? 'Mise à jour...' : 'Enregistrer' }}
        </button>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {

      isLoading: false,

      user: {
        id: null,
        nom: '',
        prenom: '',
        username: '',
        email: '',
        enabled: true,
        typeUser: null
      },

      error: {
        nom: '',
        prenom: '',
        username: '',
        email: '',
        type: ''
      },

      typesUser: []

    };
  },

  methods: {

    async getTypeUser() {
      const res = await api.getItems('type_users');
      this.typesUser = res.data.data;
    },

    async loadUser() {

      const id = this.$route.params.id;

      const res = await api.getItem('users', id);

      this.user = res.data;

      this.user.typeUser = this.user.typeUser
        ? this.user.typeUser.id
        : null;

    },

    validateForm() {

      this.error.nom = this.user.nom ? '' : 'Nom requis';
      this.error.prenom = this.user.prenom ? '' : 'Prénom requis';
      this.error.username = this.user.username ? '' : 'Username requis';
      this.error.email = this.user.email ? '' : 'Email requis';
      this.error.type = this.user.typeUser ? '' : 'Rôle requis';

      return !Object.values(this.error).some(e => e);
    },

    async updateUser() {

      if (!this.validateForm() || this.isLoading) return;

      this.isLoading = true;

      try {

        await api.updateItem('users', this.user.id, {
          ...this.user
        });

        this.$router.push({ name: 'utilisateur' });

      } catch (e) {
        console.error(e);
        alert("Erreur mise à jour");
      } finally {
        this.isLoading = false;
      }

    },

    cancel() {
      this.$router.push({ name: 'utilisateur' });
    }

  },

  created() {
    this.getTypeUser();
    this.loadUser();
  }
};
</script>

<style scoped>

/* ================= GLOBAL ================= */
.users-page {
  background: #f4f7fb;
  min-height: 100vh;
}

/* ================= HEADER ================= */
.header-boutique {
  background: linear-gradient(135deg, #0f4c81, #071a2e);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

.icon-box {
  width: 50px;
  height: 50px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

/* ================= CARD ================= */
.card-boutique {
  border: none;
  border-radius: 18px;
}

/* ================= INPUT ================= */
.form-control-boutique,
.form-select-boutique {
  border-radius: 10px;
  border: 1px solid #dbe3ee;
}

.form-control-boutique:focus,
.form-select-boutique:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 0.2rem rgba(16,185,129,0.15);
}

/* ================= SWITCH ================= */
.status-switch {
  background: #f8fafc;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

/* ================= BUTTON ================= */
.btn-primary-medical {
  background: linear-gradient(135deg, #0f4c81, #10b981);
  border: none;
  color: white;
  border-radius: 12px;
}

.btn-primary-medical:hover {
  opacity: 0.95;
}

</style>